import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const ecoinfos = 
{
    namespaced: true,
    state: {
        ecoinfos: [],
        ecoinfo: {}
    },
    mutations: {
        SET_ECOINFOS(state, data)
        {
            state.ecoinfos = data
        },
        SET_ECOINFO(state, data)
        {
            state.ecoinfo = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'GHSEcoInfo', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_ECOINFOS', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteEcoInfo ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updateEcoInfo({ commit },{id, data}){
            return axios
            .post(baseUrl+'GHSEcoInfo/updateEcoInfo/' + id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getEcoInfo ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewEcoInfo ({ commit }, data) {
            return axios
            .post(baseUrl+'GHSEcoInfo/addEcoInfo', data, { withCredentials: true })
            .then(res => {
                console.log("new eco info added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default ecoinfos